import React from 'react';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { Check } from 'lucide-react';
export const TrainingPackages = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('training-proposal-form');
    if (formSection) {
      formSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 bg-gray-50" data-id="element-1294" data-mp="uqmxdr7t4xzx">
      <div className="container mx-auto px-4" data-id="element-1295" data-mp="upla8odiol1u">
        <div className="text-center mb-16 scroll-animate" data-id="element-1296" data-mp="ush5u61w6xn4">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1297" data-mp="psus7vi5jfds">
            Training Packages
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1298" data-mp="kyqkvb4z55c6">
            Choose the right level of engagement for your team's capacity
            building needs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-1299" data-mp="1dj7cm5ul34l9">
          {/* Package 1 */}
          <Card className="scroll-animate p-8 border-2 border-gray-200 hover:border-gray-300 transition-colors h-full flex flex-col" data-id="element-1300" data-mp="1tgk0jz1ld0lp">
            <div className="mb-6" data-id="element-1301" data-mp="1yelgib3q0jsy">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1302" data-mp="1yhpqjp3va9rj">
                Starter Workshop
              </h3>
              <p className="text-gray-500 font-medium" data-id="element-1303" data-mp="1optsge1s6jnb">For small teams.</p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-1304" data-mp="1onh2bdlvd2z6">
              <div className="flex items-start" data-id="element-1305" data-mp="1ap98hek4qhs8">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1306" data-mp="1ernqxxjvzfiz" />
                <span className="text-gray-700" data-id="element-1307" data-mp="1epjgewrhfi9q">
                  Half-day or 1-day workshop
                </span>
              </div>
              <div className="flex items-start" data-id="element-1308" data-mp="15qfull0xkorj">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1309" data-mp="15r7q6vuj2mht" />
                <span className="text-gray-700" data-id="element-1310" data-mp="2v6f7nd7o6ycg">
                  Team size: up to 20 people
                </span>
              </div>
              <div className="flex items-start" data-id="element-1311" data-mp="2yntiuatjkzry">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1312" data-mp="2yol4astfdh4i" />
                <span className="text-gray-700" data-id="element-1313" data-mp="2togu1kj41imq">
                  Interactive training session
                </span>
              </div>
              <div className="flex items-start" data-id="element-1314" data-mp="2opvt1iw1aux8">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1315" data-mp="2jr2km4vltu3x" />
                <span className="text-gray-700" data-id="element-1316" data-mp="3he1gweidx01a">
                  Digital learning materials
                </span>
              </div>
            </div>

            <Button variant="outline" className="w-full py-3" onClick={scrollToForm} data-id="element-1317" data-mp="3cfzyzwwp36re">
              Request Proposal
            </Button>
          </Card>

          {/* Package 2 - Highlighted */}
          <Card className="scroll-animate p-8 border-2 border-primary shadow-xl relative transform lg:-translate-y-4 h-full flex flex-col bg-white z-10" data-id="element-1318" data-mp="32ovi2rnglbtx">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-1319" data-mp="3vdkbs5m6qevn">
              <span className="bg-primary text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-1320" data-mp="7hu6f1k9s7dl">
                Most Popular
              </span>
            </div>

            <div className="mb-6 mt-2" data-id="element-1321" data-mp="gia6s25puye8">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1322" data-mp="gh8yu6jzys0q">
                Team Transformation
              </h3>
              <p className="text-primary font-medium" data-id="element-1323" data-mp="lieo1ueg7x5i">
                For organizations building capacity.
              </p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-1324" data-mp="uh9w7c11zhbg">
              <div className="flex items-start" data-id="element-1325" data-mp="ufp2fomkc2en">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1326" data-mp="z88f8jdfetie" />
                <span className="text-gray-700 font-medium" data-id="element-1327" data-mp="147blg75575ry">
                  2–3 day training program
                </span>
              </div>
              <div className="flex items-start" data-id="element-1328" data-mp="19892ggef1trv">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1329" data-mp="1e5izah44x7pq" />
                <span className="text-gray-700 font-medium" data-id="element-1330" data-mp="1e3eqbkrdpiil">
                  Customized curriculum
                </span>
              </div>
              <div className="flex items-start" data-id="element-1331" data-mp="25x1ift8qc8sh">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1332" data-mp="25w8hj8wgcdi9" />
                <span className="text-gray-700 font-medium" data-id="element-1333" data-mp="2km63rjatmt4t">
                  Practical exercises & labs
                </span>
              </div>
              <div className="flex items-start" data-id="element-1334" data-mp="1rxs46z433or5">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1335" data-mp="1ryjv3wmqkyb3" />
                <span className="text-gray-700 font-medium" data-id="element-1336" data-mp="1n0rw6inocbxe">
                  Post-training resources
                </span>
              </div>
              <div className="flex items-start" data-id="element-1337" data-mp="1wxmrytskby7z">
                <Check className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-1338" data-mp="1wvtjra2ax5xv" />
                <span className="text-gray-700 font-medium" data-id="element-1339" data-mp="3cd3tqflszzml">
                  Impact assessment report
                </span>
              </div>
            </div>

            <Button className="w-full py-4 text-lg shadow-md hover:shadow-lg" onClick={scrollToForm} data-id="element-1340" data-mp="3fwcb1leafom4">
              Request Proposal
            </Button>
          </Card>

          {/* Package 3 */}
          <Card className="scroll-animate p-8 border-2 border-gray-200 hover:border-gray-300 transition-colors h-full flex flex-col" data-id="element-1341" data-mp="35y4wf97h1ina">
            <div className="mb-6" data-id="element-1342" data-mp="3ay10f8g65a2u">
              <h3 className="text-2xl font-bold text-navy mb-2" data-id="element-1343" data-mp="3az2ezmwe8epb">
                Institutional Partnership
              </h3>
              <p className="text-gray-500 font-medium" data-id="element-1344" data-mp="7fzoan3o5d6v">
                For schools and organizations.
              </p>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-1345" data-mp="3ovze0bmo12ha">
              <div className="flex items-start" data-id="element-1346" data-mp="3tvu267f23dyn">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1347" data-mp="3tuiz69tfqa8l" />
                <span className="text-gray-700" data-id="element-1348" data-mp="leza7mzsrdzc">
                  Long-term learning partnership
                </span>
              </div>
              <div className="flex items-start" data-id="element-1349" data-mp="q8ttipbhpqxw">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1350" data-mp="102zadfs76ism" />
                <span className="text-gray-700" data-id="element-1351" data-mp="v34ojqna4jef">
                  Multiple training sessions per year
                </span>
              </div>
              <div className="flex items-start" data-id="element-1352" data-mp="r07yxfzbnn0z">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1353" data-mp="m3hiusniorfk" />
                <span className="text-gray-700" data-id="element-1354" data-mp="h3v94t6wdtbi">Program design support</span>
              </div>
              <div className="flex items-start" data-id="element-1355" data-mp="cd52lcmqjkf8">
                <Check className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1356" data-mp="ccd701t51moy" />
                <span className="text-gray-700" data-id="element-1357" data-mp="7f3hyn9nvd1n">
                  Community access to The Networking Salon network
                </span>
              </div>
            </div>

            <Button variant="outline" className="w-full py-3" onClick={scrollToForm} data-id="element-1358" data-mp="3ujb059poa6xo">
              Request Proposal
            </Button>
          </Card>
        </div>
      </div>
    </section>;
};